module.exports = __webpack_public_path__ + "static/video-lightindream-7edb73ce809d0d07741a035a583a6478.mp4";